import React from 'react';
import { isTeamChatEnabled } from '../featureFlag';
import { TeamChatProvider } from './TeamChatContext';
import { TeamChatWindowsPortal } from '../components/TeamChatWindowsPortal';
import { TeamChatDock } from '../components/TeamChatDock';
import { TeamChatEventBridge } from '../components/TeamChatEventBridge';

export function TeamChatBootstrap({ children }: { children: React.ReactNode }) {
  if (!isTeamChatEnabled()) return <>{children}</>;
  return (
    <TeamChatProvider>
      <TeamChatEventBridge />
      {children}
      <TeamChatWindowsPortal />
      <TeamChatDock />
    </TeamChatProvider>
  );
}
